import { Component, AfterContentInit, OnDestroy, ElementRef, ViewChild, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { DialogService } from 'primeng-lts/dynamicdialog';
import { PlycaErrorHandler } from '../../../../http/PlycaErrorHandler';
import { PlycaDataService } from '../../../../services/plyca.service';
import { BaseComponent } from '../../../components/common/baseComponent/base.component';
import { HelpService } from '../../../components/common/help/help.service';
import { HeaderActionsService } from '../../../components/common/sub-header/header-actions.service';
import { WaitLoadingService } from '../../../components/common/waitLoading/wait-loading.service';
import { FormConfig } from '../../../components/forms/form.objects';
import { formPlycaComponent } from '../../../components/forms/formPlyca.component';
import { Configuration } from '../../../conf/app.constants';
import { UIService } from '../../../ui.service';
import { UserService } from '../../../user.service';
import { ActionResultDTO } from '../../../api/plyca-dtos-v2';



@Component({
  selector: 'supportEventPanel',
  templateUrl: 'supportEventPanel.template.html',
  providers: [DatePipe, DialogService]
})
export class SupportEventPanelComponent extends BaseComponent implements AfterContentInit, OnDestroy, OnInit {
  private loaded = false;

  @ViewChild('formPlycaRef') formPlycaRef1: formPlycaComponent;
  public formConfig: FormConfig;
  private formModel: any;

  constructor(
    public plycaService: PlycaDataService,
    public configuration: Configuration,
    public helpService: HelpService,
    public uiService: UIService,
    public userService: UserService,
    public waitService: WaitLoadingService,
    private headerActionsService: HeaderActionsService,
    private elem: ElementRef,
    public dialogService: DialogService,
    private plycaErrorHandler: PlycaErrorHandler,
    public translate: TranslateService
  ) {
    super();
    this.initForm();
  }

  ngOnInit(): void {
  }

  ngAfterContentInit(): void {
    console.log('ngAfterContentInit');
    this.headerActionsService.setTaskDescription(
      this.elem,
      'adaptation.cixtec.bitacoraIntegration.supportEventForm.title',
      'fas fa-headset',
      this.isLoaded.bind(this));
    this.subscribe(
      this.headerActionsService.addAction(
        'adaptation.cixtec.bitacoraIntegration.supportEventForm.buttons.sendSupportEvent',
        'fas fa-paper-plane',
        'btn-primary',
        true
      ), success => {
        this.cmdCreateSupportEvent();
      });

    this.headerActionsService.addDivider();
    this.subscribe(this.headerActionsService.addAction(
      'General.back',
      'fas fa-chevron-left',
      'btn-outline-secondary',
      true
    ), success => {
      this.uiService.routeBack();
    });
    this.loaded = true;
  }

  ngOnDestroy() {
    console.log('ngOnDestroy');
    this.headerActionsService.clearActions();
    super.ngOnDestroy();
  }

  public isLoaded(): boolean {
    return this.loaded;
  }

  private clearForm() {
    console.log('*****');
    console.log(this.formModel);
    // this.formModel.data = {};
    // Se borran los datos del formulario menos el anagrama
    let arrayKeysExcept = ['userIdentifier'];



    Object.keys(this.formModel.data).forEach(
      key => {
        if (arrayKeysExcept.indexOf(key) === -1) {
          delete this.formModel.data[key];

        }
      });
    if (this.formModel.ui.eventImportanceValues.length > 2) {
      this.formModel.data.eventImportance =
        this.formModel.ui.eventImportanceValues[2].value; // Preseleccionamos el tercer valor 'Media'
    }
  }
  private initForm() {
    // Inicializar formModel
    this.formModel = {};
    this.formModel.ui = {};
    this.formModel.ui.eventCategoryValues = [];
    this.formModel.ui.eventTypeValues = [];
    this.formModel.ui.eventImportanceValues = [];
    this.formModel.data = {};

    // Datos del modelo
    this.loadDropdownListValues(this.formModel.ui.eventCategoryValues, 'adaptation.cixtec.bitacoraIntegration.supportEventForm.listsValues.eventCategory');
    this.loadDropdownListValues(this.formModel.ui.eventTypeValues, 'adaptation.cixtec.bitacoraIntegration.supportEventForm.listsValues.eventType');

    // Usuario
    this.formModel.data.userIdentifier = this.userService.sessionInfo.user.identifier;

    // Lista desplegable: Importancia
    {
      this.formModel.ui.eventImportanceValues = [];
      this.translate.get('adaptation.cixtec.bitacoraIntegration.supportEventForm.listsValues.eventImportance')
        .subscribe(translatedValues => {
          if (this.formModel.ui.eventImportanceValues) {
            translatedValues.forEach(translatedValue => {
              this.formModel.ui.eventImportanceValues.push({ 'label': translatedValue, 'value': translatedValue })
            });
            if (this.formModel.ui.eventImportanceValues.length > 2) {
              this.formModel.data.eventImportance =
                this.formModel.ui.eventImportanceValues[2].value; // Preseleccionamos el tercer valor 'Media'
            }
          }
        });
    }



    // Crear la configuración del formulario
    this.subscribe(
      of(new FormConfig(undefined,
        'cixtec/supportEventPanelSettings.json',
        this.formModel
      )),
      (formConfig: FormConfig) => {
        this.formConfig = formConfig;
      });
  }

  private cmdCreateSupportEvent() {

    this.waitService.startWaiting();

    console.log(this.formModel);

    if (this.formModel != null && this.formModel.data != null) {

      if (!this.formModel.data.userIdentifier || this.formModel.data.userIdentifier === ''
        || !this.formModel.data.eventType || this.formModel.eventType === ''
        || !this.formModel.data.eventImportance || this.formModel.data.eventImportance === ''
        || !this.formModel.data.eventSubject || this.formModel.data.eventSubject === ''
        || !this.formModel.data.eventDescription || this.formModel.data.eventDescription === ''
      ) {

        this.uiService.showMessage(this.translate.instant('adaptation.cixtec.bitacoraIntegration.supportEventForm.messages.requiredDataError'),
          this.translate.instant('General.error'));

      } else {


        let extensionContext: any = {
          'processInformation': {
            'className': 'com.nexusit.plyca.adaptation.cixtec.integration.bitacora.extension.CreateSupportEventExtension'
          },
          'inputData': {
            'eventType': this.formModel.data.eventType,
            'eventImportance': this.formModel.data.eventImportance,
            'eventCategory': this.formModel.data.eventCategory,
            'contractFolderId': this.formModel.data.projectEntity?.contractFolderId,
            'eventSubject': this.formModel.data.eventSubject,
            'eventDescription': this.formModel.data.eventDescription,
            'attachedFilesIdentifier': this.formModel.data.attachedFiles?.map(attachedFile => { return attachedFile?.identifier })
          }
        };
        const extensionContextAsString = JSON.stringify(extensionContext);
        console.log('contextAsString=' + extensionContextAsString);
        this.subscribe(


          this.plycaService.runActionByName('ACTION_INVOKE_EXTENSION', 'context=' + extensionContextAsString).pipe(
            tap(

              (result: ActionResultDTO) => {


                if (result && result.identifier === 'OK') {
                  this.uiService.showSuccess(
                    this.translate.instant('adaptation.cixtec.bitacoraIntegration.supportEventForm.messages.supportEventCreateProcessResultSuccess'),
                    this.translate.instant('General.info'),
                    'success'
                  );


                  this.clearForm();



                } else {
                  this.plycaErrorHandler.showServerError(
                    this.translate.instant('adaptation.cixtec.bitacoraIntegration.supportEventForm.messages.supportEventCreateProcessResultError')
                  );

                }
                this.waitService.cancelWaiting();




              }),

            catchError((error) => {
              this.plycaErrorHandler.showServerError(this.translate.instant('adaptation.cixtec.bitacoraIntegration.supportEventForm.messages.supportEventCreateProcessResultError'));
              this.clearForm();
              return of(error);
            })
          )


        );

      }
    } else {
      this.plycaErrorHandler.showServerError(
        this.translate.instant('adaptation.cixtec.bitacoraIntegration.supportEventForm.messages.supportEventCreateProcessResultError')
      );
      this.waitService.cancelWaiting();
    }
  }

  private loadDropdownListValues(dropdownListValues: any, tranlateKeys: string) {
    this.translate.get(tranlateKeys).subscribe(translatedValues => {
      if (translatedValues) {
        translatedValues.forEach(translatedValue => {
          dropdownListValues.push({ 'label': translatedValue, 'value': translatedValue })
        });
      }
    });
  }
}
